module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/294.6ac64253.png";